import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { useAuth } from "../lib/auth-context";
import { toast } from "sonner";

/**
 * One-click demo login. Calls /api/auth/login with email + demo1234,
 * then routes to the appropriate role-based home.
 */
export default function QuickLoginButton({
    email,
    label,
    role,
    icon: Icon,
    color = "#0066FF",
    variant = "filled",
    testid,
}) {
    const { login } = useAuth();
    const nav = useNavigate();
    const [busy, setBusy] = useState(false);

    const handle = async () => {
        setBusy(true);
        try {
            const u = await login(email, "demo1234");
            toast.success(`Signed in as ${u.full_name.split(" ")[0]}`);
            const home = u.role === "admin" ? "/admin" : u.role === "business" ? "/business" : "/consumer";
            nav(home, { replace: true });
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Demo login failed");
        } finally {
            setBusy(false);
        }
    };

    if (variant === "outline") {
        return (
            <Button
                onClick={handle}
                disabled={busy}
                variant="outline"
                data-testid={testid || `quick-login-${role}`}
                className="font-semibold rounded-xl h-11 px-5 border-2 hover:scale-[1.02] transition gap-2"
                style={{ borderColor: color, color }}
            >
                {Icon && <Icon size={18} />}
                {busy ? "Signing in…" : label}
            </Button>
        );
    }

    return (
        <Button
            onClick={handle}
            disabled={busy}
            data-testid={testid || `quick-login-${role}`}
            className="rounded-xl h-11 px-5 font-semibold text-white hover:scale-[1.02] transition gap-2"
            style={{ background: color }}
        >
            {Icon && <Icon size={18} />}
            {busy ? "Signing in…" : label}
        </Button>
    );
}
